import bowser from 'yola-bowser';
import textFormatting from '../../text-formatting';

const deleteContents = (range) => {
  // Safari has a bug (https://github.com/yola/production/issues/15837) where `range.deleteContents()` can cause the browser to reload when deleting content that includes custom elements. Using `range.extractContents()` instead avoids this issue and safely removes the selected content in Safari.
  if (bowser.safari) {
    range.extractContents();
  } else {
    range.deleteContents();
  }
};

const removeSelection = () => {
  const selection = textFormatting.accessors.getAdvancedSelection();

  if (!selection.isCollapsed) {
    const range = selection.getRangeAt(0);
    deleteContents(range);
    range.collapse();
    selection.refresh();
  }
};

export default removeSelection;
